@if (!selectedItemsLoaded) {
  <div>
    <se-fe-spinner [seFeDataSize]="900" [seFeDataCenter]="true"></se-fe-spinner>
  </div>
}

@if (selectedItemsLoaded) {
  <div>
    <se-fe-grid seFeGridOpts="spaced">
      <se-fe-grid-cell seFeGridOpts>
        <div class="item-variation-select">
          <se-fe-modal-button
            [seFeDataButton]="{ label: 'Select Eligible Items', secondary: true }"
          (seFeButtonAction)="openEligibleItemDialog()"></se-fe-modal-button>
          <div class="items-selected">
            <span>
              {{ this.amountSelected + (this.amountSelected === 1 ? ' sale item selected' : ' sale items selected') }}
            </span>
          </div>
        </div>
      </se-fe-grid-cell>
    </se-fe-grid>
    <div [hidden]="this.amountSelected < 1">
      <se-fe-grid seFeGridOpts>
        <se-fe-grid-cell seFeGridOpts>
          <div>
            <table #displayTable seFeTable title="Selected Items" [dataSource]="displayTableDataSource$ | async">
              <ng-container seFeColumnDef="name">
                <th seFeHeaderCell seFeDataRef="name" *seFeHeaderCellDef>Sale Item</th>
                <td seFeCell *seFeCellDef="let row">{{ row.full_name }}</td>
              </ng-container>
              <ng-container seFeColumnDef="sku">
                <th seFeHeaderCell seFeDataRef="sku" *seFeHeaderCellDef>SKU</th>
                <td seFeCell *seFeCellDef="let row">{{ row.sku }}</td>
              </ng-container>
              <ng-container seFeColumnDef="price">
                <th seFeHeaderCell seFeDataRef="price" *seFeHeaderCellDef>Price</th>
                <td seFeCell *seFeCellDef="let row">{{ row.price | currency }}</td>
              </ng-container>
              <ng-container seFeColumnDef="remove">
                <th seFeHeaderCell *seFeHeaderCellDef></th>
                <td seFeCell *seFeCellDef="let row" width="10">
                  <se-fe-button [seFeDataEmphasis]="'medium'" (click)="removeItem(row.id)">Remove</se-fe-button>
                </td>
              </ng-container>
              <tr seFeHeaderRow *seFeHeaderRowDef="displayTableColumns.value; sticky: false"></tr>
              <tr seFeRow *seFeRowDef="let row; columns: displayTableColumns.value"></tr>
            </table>
          </div>
          <div>
            {{ this.amountSelected + (this.amountSelected === 1 ? ' sale item selected' : ' sale items selected') }}
          </div>
        </se-fe-grid-cell>
      </se-fe-grid>
    </div>
    <dialog
      #eligibleItemDialog
      class="eligible-item-dialog"
      aria-labelledby="eligible-item-dialog-title"
      (cancel)="handleDialogCancel($event)"
      (click)="handleDialogClick($event)"
      (close)="handleModalClose()">
      <div class="eligible-item-dialog__surface">
        <header class="eligible-item-dialog__header">
          <h2 id="eligible-item-dialog-title">Select Eligible Items</h2>
          <button class="eligible-item-dialog__close" type="button" aria-label="Close" (click)="resetSelection()">
            <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M6.4 5 12 10.6 17.6 5 19 6.4 13.4 12 19 17.6 17.6 19 12 13.4 6.4 19 5 17.6 10.6 12 5 6.4z" />
            </svg>
          </button>
        </header>
        <div class="eligible-item-dialog__content">
          <se-fe-grid seFeGridOpts>
            <se-fe-grid-cell seFeGridOpts>
              @if (validationError) {
                <se-fe-alert [seFeDataType]="'error'">
                  {{ validationError }}
                </se-fe-alert>
              }
              <div>{{ modalHeader }}</div>
            </se-fe-grid-cell>
          </se-fe-grid>
          <se-fe-grid seFeGridOpts>
            <se-fe-grid-cell seFeGridOpts>
              <se-fe-toolbar [seFeDataQuery]="searchTerm" (seFeQueryChange)="search($event)"></se-fe-toolbar>
              @if (!isLoaded) {
                <div>
                  <se-fe-spinner [seFeDataSize]="900" [seFeDataCenter]="true"></se-fe-spinner>
                </div>
              }
              <div [hidden]="!isLoaded || itemVariationList.length">
                <se-fe-empty-state seFeDataTitle="No Results" seFeDataSize="500">
                  Try adding sale items or changing your search terms
                </se-fe-empty-state>
              </div>
              @if (selectForm) {
                <form [formGroup]="selectForm">
                  @if (isLoaded && itemVariationList.length) {
                    <div>
                      <table #selectTable seFeTable title="Select Eligible Items" style="max-height: 400px">
                        <ng-container seFeColumnDef="checkbox">
                          <th seFeHeaderCell *seFeHeaderCellDef>
                            <se-fe-checkbox formControlName="selectAll" [seFeDataOptions]="selectAllOptions"></se-fe-checkbox>
                          </th>
                          <td seFeCell *seFeCellDef="let row">
                            <se-fe-checkbox
                              [formControlName]="row.id"
                            [seFeDataOptions]="[{ label: 'check', value: true, hiddenLabel: true }]"></se-fe-checkbox>
                          </td>
                        </ng-container>
                        <ng-container seFeColumnDef="name">
                          <th seFeHeaderCell seFeDataRef="name" *seFeHeaderCellDef>Name</th>
                          <td seFeCell *seFeCellDef="let row">{{ row.full_name }}</td>
                        </ng-container>
                        <ng-container seFeColumnDef="sku">
                          <th seFeHeaderCell seFeDataRef="sku" *seFeHeaderCellDef>SKU</th>
                          <td seFeCell *seFeCellDef="let row">{{ row.sku }}</td>
                        </ng-container>
                        <ng-container seFeColumnDef="price">
                          <th seFeHeaderCell seFeDataRef="price" *seFeHeaderCellDef>Price</th>
                          <td seFeCell *seFeCellDef="let row">{{ row.price | currency }}</td>
                        </ng-container>
                        <tr seFeHeaderRow *seFeHeaderRowDef="selectTableColumns.value; sticky: false"></tr>
                        <tr seFeRow *seFeRowDef="let row; columns: selectTableColumns.value"></tr>
                      </table>
                      @if (isLoaded) {
                        <se-fe-pagination
                          [seFeDataPaginationOptions]="paginationOptions"
                        (seFePaginationChange)="handlePagination($event)"></se-fe-pagination>
                      }
                    </div>
                  }
                </form>
              }
            </se-fe-grid-cell>
          </se-fe-grid>
        </div>
        <footer class="eligible-item-dialog__footer">
          <se-fe-button-group>
            <se-fe-modal-button
              [seFeDataButton]="{ label: 'Cancel', cancel: true }"
            (seFeButtonAction)="resetSelection()"></se-fe-modal-button>
            <se-fe-modal-button
              [seFeDataButton]="{ label: 'Submit', primary: true }"
            (seFeButtonAction)="saveSelection()"></se-fe-modal-button>
          </se-fe-button-group>
        </footer>
      </div>
    </dialog>
  </div>
}
